// NOTE: NSAI-6427 — the one question every "may this surface still show the
// platform's own artwork?" rule has to ask first: has this organization put any
// branding of its own on screen?
//
// It lives here rather than in either app because both ask it, of the same three
// fields, from the same endpoints — web for the empty-chat mark and the auth
// illustration, mobile for its default-appearance artwork — and because the
// answer being wrong looks the same on both: a white-label customer shown the
// platform's logo inside their own product.
//
// Three signals, OR'd, because an organization brands itself in whichever order
// suits it and any ONE of them is already someone else's product:
//   - a custom stylesheet (`/theme/css`, `/theme/me`),
//   - an uploaded logo (`hasLogo` — a flag rather than a fetch, because
//     `/theme/logo` answers with the platform default when there is none),
//   - a product name of its own (`appName`).
// Reading only the stylesheet is what this ticket exists to fix: it called an
// organization whose whole branding was one uploaded logo unbranded.
//
// The favicon is deliberately NOT a fourth signal. It is a browser-tab icon
// that no in-app surface renders, so an organization that uploaded one and
// nothing else has not yet replaced anything a rule here would hide.
export interface IHasOwnOrgBrandingProps {
  hasCustomCss: boolean;
  hasLogo: boolean;
  appName: string | null;
}

export const hasOwnOrgBranding = ({
  hasCustomCss,
  hasLogo,
  appName,
}: IHasOwnOrgBrandingProps): boolean => {
  // NOTE: A whitespace-only name is "not set" — the same reading the server
  // gives it when it stores a blank name as null.
  return hasCustomCss || hasLogo || !!appName?.trim();
};
